import { Heart, Share2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { FavoriteType } from '../../services/favoritesApi';
import { btnGhostSm } from '../ui/redesign';

import { useSiteActions } from './siteActionsContext';

interface DetailActionsProps {
  type: FavoriteType;
  /** Database id of the activity, course or Pick. */
  targetId: string;
  /** Canonical page path to share, e.g. /activity/slug or /courses/slug (PRD F8). */
  sharePath: string;
  title: string;
  className?: string;
}

/** Secondary action row on detail pages: save and share (PRD §5.9 F3, F8). */
export default function DetailActions({
  type,
  targetId,
  sharePath,
  title,
  className = '',
}: DetailActionsProps) {
  const { t } = useTranslation('common');
  const { isFavorite, toggleFavorite, share } = useSiteActions();
  const saved = isFavorite(type, targetId);
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      <button
        type="button"
        className={`${btnGhostSm} ${saved ? 'text-heart' : ''}`}
        aria-pressed={saved}
        onClick={() => toggleFavorite(type, targetId)}
      >
        <Heart className={`h-4 w-4 ${saved ? 'fill-current' : ''}`} aria-hidden="true" />
        {saved ? t('favorite.saved') : t('favorite.add')}
      </button>
      <button type="button" className={btnGhostSm} onClick={() => share(sharePath, title)}>
        <Share2 className="h-4 w-4" aria-hidden="true" />
        {t('share.button')}
      </button>
    </div>
  );
}
